import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(legal)/layout.tsx");
